import { render, staticRenderFns } from "./QuirofanoNuevaCirugia.vue?vue&type=template&id=263a3520&"
import script from "./QuirofanoNuevaCirugia.vue?vue&type=script&lang=js&"
export * from "./QuirofanoNuevaCirugia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports